export const demandaInducidaRoutes = [
  {
    path: '/demandainducida',
    name: 'Demanda Inducida',
    component: () =>
      import(
        /* webpackChunkName: "demandainducida" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiPhoneForward',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Demanda Inducida',
      requiresSession: true,
      perfiles: ['DEMANDA INDUCIDA', 'COORDINADOR ASISTENCIAL'],
      showBackButton: false
    },
    children: [
      {
        path: '/demandainducida/alertas',
        name: 'Alertas',
        component: () =>
          import(
            /* webpackChunkName: "demandainducida" */ '@/modules/DemandaInducida/views/DemandaInducida/AlertasIndex.vue'
          ),
        icon: 'mdiAlert',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Alertas',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/demandainducida/index',
        name: 'DemandaInducidaIndex',
        component: () =>
          import(
            /* webpackChunkName: "demandainducida" */ '@/modules/DemandaInducida/views/DemandaInducida/DemandaInducidaIndex.vue'
          ),
        icon: 'mdiHome',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Gestión de Demandas',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/demandainducida/paciente/:copeId',
        name: 'DemandaInducidaPaciente',
        component: () =>
          import(
            /* webpackChunkName: "demandainducida" */ '@/modules/DemandaInducida/views/DemandaInducida/DemandaInducidaPacienteView.vue'
          ),
        icon: 'mdiAccount',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Demandas del Paciente',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: true
        },
        children: []
      },
      {
        path: '/demandainducida/detalle/:deinId',
        name: 'DemandaInducidaDetalle',
        component: () =>
          import(
            /* webpackChunkName: "demandainducida" */ '@/modules/DemandaInducida/views/DemandaInducida/DemandaInducidaDetalleView.vue'
          ),
        icon: 'mdiFileDocument',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Detalle de Demanda',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: true
        },
        children: []
      }
    ]
  }
]
